import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-image-with-text-conven-feet-03.js';
const html = `
<div data-use-custom-width="false" data-custom-width="1204" class="container-03" data-attribute="container-content"
    style="--custom-width: 1204px;">
    <div data-attribute="wrap-card" data-center-y="true" data-gap-item="24" class="wrap-card" style="--gap-item: 24px;">
        <div data-attribute="wrap-image" data-order="1" style="--order-image: 1;" class="wrap-image">
            <div class="wrap-image-item">
                <img data-attribute="image-item"
                    src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ec717e19e4d257ca1b23.png"
                    alt="">
            </div>
        </div>
        <div class="wrap-content" data-attribute="wrap-content" data-order="2" data-background-content="#006196"
            style="--order-content: 2; --background-content: #006196;">
            <div data-show="true" data-attribute="wrap-title" class="wrap-title">
                <h2>Proven To Increase Comfort &amp; Mobility</h2>
                <p>&nbsp;</p>
                <p>Stop letting foot pain dictate your day. Our orthopedic design targets the root cause of discomfort,
                    giving you the freedom to move with zero pain.</p>
            </div>
            <div data-attribute="block-icon-with-text" class="block-icon-with-text">
                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                    <div class="wrap-icon">
                        <img data-attribute="icon-item"
                            src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ecad61dc759b38d88a12.png"
                            alt="">
                    </div>
                    <div data-attribute="wrap-text" class="wrap-text">
                        <h3>
                            Total Foot Relief
                        </h3>
                        <p>Aching feet slowing you down? <br>Our expert-designed cushioning for cloud-like comfort that
                            lasts all day will help!</p>
                    </div>
                </div>

                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                    <div class="wrap-icon">
                        <img data-attribute="icon-item"
                            src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ecb1f05b93eb4383011a.png"
                            alt="">
                    </div>
                    <div data-attribute="wrap-text" class="wrap-text">
                        <h3>
                            <meta charset="utf-8">Plantar Fasciitis Support
                        </h3>
                        <p>A sharp pain in the heel can ruin your morning! Our 98% Gel Damping Sole instantly soothes
                            heel inflammation and sharp pain.</p>
                    </div>
                </div>

                <div data-attribute="item-icon-with-text" class="item-icon-with-text">
                    <div class="wrap-icon">
                        <img data-attribute="icon-item"
                            src="https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1ecb5422e95ec029b2c93.png"
                            alt="">
                    </div>
                    <div data-attribute="wrap-text" class="wrap-text">
                        <h3>
                            <meta charset="utf-8">Bunion &amp; Wide-Foot Friendly
                        </h3>
                        <p>Flexible, wide toe-box ends the squeeze and protects sensitive joints.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export default containerFuild(html, css, {
  textColor: '#FFFFFF',
});
